var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineHeartAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.65 17.2c0-3.06 2.49-5.55 5.55-5.55 3.06 0 5.55 2.49 5.55 5.55 0 3.06-2.49 5.55-5.55 5.55-3.06 0-5.55-2.49-5.55-5.55zm1.5 0c0 2.23 1.82 4.05 4.05 4.05 2.23 0 4.05-1.82 4.05-4.05 0-2.23-1.82-4.05-4.05-4.05-2.23 0-4.05 1.82-4.05 4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 18.01c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.59a.749.749 0 1 1 0 1.5H15.4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.45 19.1v-3.59c0-.41.34-.75.75-.75s.75.34.75.75v3.59c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 21.52c-2.56-.87-9.88-5.11-9.88-12.83 0-3.5 2.83-6.34 6.31-6.34 1.67 0 3.27.67 4.44 1.84a6.308 6.308 0 0 1 4.44-1.84c3.48 0 6.31 2.84 6.31 6.34 0 1.95-.47 3.82-1.4 5.57a.74.74 0 0 1-.56.39.747.747 0 0 1-.65-.23 4.05 4.05 0 0 0-2.95-1.28c-2.23 0-4.05 1.82-4.05 4.05 0 .99.37 1.95 1.04 2.7.16.18.22.42.17.65-.05.23-.21.43-.42.53-.4.18-.76.33-1.09.44-.23.1-.53.14-.84.14-.31 0-.62-.04-.87-.13zM2.75 8.69c0 6.84 6.57 10.62 8.87 11.41.18.07.57.06.75 0l.09-.03c-.52-.86-.81-1.85-.81-2.87a5.557 5.557 0 0 1 8.79-4.51c.54-1.28.81-2.62.81-4 0-2.67-2.16-4.84-4.81-4.84-1.5 0-2.94.72-3.84 1.93-.28.38-.92.38-1.2 0a4.812 4.812 0 0 0-3.84-1.93c-2.65 0-4.81 2.17-4.81 4.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHeartAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-heart-add.9604b9721e12d0252bc8e693a273cf17.svg";
export { ForwardRef as ReactComponent };